import { Inject, Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';

import { STORAGE_KEY } from '../../definitions/app.constants';
import { environment } from '../../../environments/environment';
import { LEARNING_HUB_CONFIG } from '../definitions/learning-hub.constants';
import { LearningHubConfig } from '../definitions/learning-hub.models';

/**
 * Visibility of /learning-hub, configured with environment.learningHub.visibility:
 *  - 'public' (default): anyone with the link, the route is not protected.
 *  - 'authenticated': needs the session token (same check PermissionGuard does first);
 *    otherwise the user is sent to the session module. No per-module permission is required.
 * CanLoad keeps the lazy chunk from downloading for anonymous users; CanActivate re-checks on every
 * navigation (e.g. after a logout in the same tab, when the chunk is already loaded).
 */
@Injectable({ providedIn: 'root' })
export class LearningHubAccessGuard implements CanLoad, CanActivate {
  constructor(
    private readonly _router: Router,
    @Inject(LEARNING_HUB_CONFIG) private readonly _config: LearningHubConfig
  ) {}

  canLoad(): boolean | UrlTree {
    return this._check();
  }

  canActivate(): boolean | UrlTree {
    return this._check();
  }

  private _check(): boolean | UrlTree {
    if (this._config.visibility === 'public' || localStorage.getItem(STORAGE_KEY.token)) {
      return true;
    }
    return this._router.createUrlTree(['/', environment.modules.session]);
  }
}
